var render = function render(_c,_vm){return _c('div',_vm._b({staticClass:"DashboardFiltersV2Item",class:[_vm.data.class,_vm.data.staticClass]},'div',_vm.data.attrs,false),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }